import { render, staticRenderFns } from "./ReorderDocumentsDialog.vue?vue&type=template&id=c1ea82a2"
import script from "./ReorderDocumentsDialog.vue?vue&type=script&lang=js"
export * from "./ReorderDocumentsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports